var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "currency-img currency-error-img",
      class: [_vm.spver === 1 ? "default-film" : "default-sogou"],
    },
    [
      _vm.index < 5
        ? _c("div", { staticClass: "normal-img" }, [
            _c("img", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.error,
                  expression: "!error",
                },
              ],
              staticClass: "currency-default-img",
              attrs: {
                src: _vm.imgUrlDeal(_vm.src),
                referrerpolicy: "no-referrer",
                alt: _vm.alt,
              },
              on: { error: _vm.imgError },
            }),
          ])
        : _c("img", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: !_vm.error,
                expression: "!error",
              },
            ],
            staticClass: "currency-default-img",
            attrs: {
              src: _vm.imgUrlDeal(_vm.src),
              loading: "lazy",
              referrerpolicy: "no-referrer",
              alt: _vm.alt,
            },
            on: { error: _vm.imgError },
          }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }